<div class="modal-header" nfModalVariant="warning" hsDraggable="modal-dialog">
  <h4 class="modal-title">Uncommitted Changes Detected</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <h3>
    You are about to close an open session for account
    {{ accountIds.join(', ') }} which has {{ changes }} uncommitted changes.
  </h3>
  <div class="form-group option-content">
    <nf-form-control label="What would you like to do with these changes?">
      <nf-radio-group [formControl]="radioInline">
        <nf-radio-button
          class="option-content"
          label="Discard changes"
          [value]="DISCARD"
        ></nf-radio-button>
        <nf-radio-button
          label="Run account with ETLs"
          [value]="RUN_WITH_ETLS"
        ></nf-radio-button>
        <nf-radio-button
          label="Run account without ETLs"
          [value]="RUN_WITHOUT_ETLS"
        ></nf-radio-button>
      </nf-radio-group>
    </nf-form-control>
  </div>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button="cancel" (click)="activeModal.dismiss()">Cancel</button>
  <button
    id="modal-submit-button"
    nf-button="primary"
    [disabled]="action == null"
    (click)="submit()"
    data-cy="continue-modal-button"
  >
    Close Session
  </button>
</div>
